/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Treadmill/millSpring.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation12.play();
    actions.Animation12.repetitions = 1;
    actions.Animation12.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="spring" geometry={nodes.spring.geometry} material={materials.彈黃} />
      </group>
    </group>
  )
}

useGLTF.preload('/Treadmill/millSpring.glb')
